import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { RoleListComponent } from './role-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [RoleListComponent],
  declarations: [RoleListComponent],
})
export class RoleListModule { }
